import axios from "axios";
import { useState, useEffect, useContext } from "react";
import { CredentialContext } from '../context/CredentialContext';

function useCredentialData(workspace) {
  const [error, setError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const { updateCredentials } = useContext(CredentialContext);
  const credentialsUrl = "/" + workspace + "/credentials/oauth2";
  let oAuthCredentials = [];
  
  useEffect(() =>{
    axios.get(credentialsUrl, { withCredentials: true })
    .then(res => {
      oAuthCredentials = res.data.data;
      updateCredentials(oAuthCredentials)
      setIsLoaded(true);
    },
    (error) => {
      setError(true);
      setIsLoaded(true);
    })
  }, [credentialsUrl])
  return { error, isLoaded, oAuthCredentials }
}

export default useCredentialData;